import React from "react";
import { Input, Row, Col, Typography, Card, Form } from "antd";
import NeedHelpIcon from "../NeedHelpIcon/NeedHelpIcon";

const { Title } = Typography;

const CompanyContactInformation = () => {
  return (
    <Card style={{ width: "100%" }}>
      <Row style={{ justifyContent: "space-between", width: "100%" }}>
        <Col>
          <Title level={3}>Kontaktinformasjon</Title>
        </Col>
        <Col>
          <NeedHelpIcon />
        </Col>
      </Row>

      <Title level={5}>Kontaktperson</Title>
      <Row gutter={24}>
        <Col md={12} sm={24} xs={24}>
          <Form.Item
            label="Fornavn"
            name="first_name"
            rules={[
              {
                required: true,
                message: "Skriv inn fornavn",
              },
              { max: 255, message: "Fornavn kan ikke være lengre enn 255 tegn" },
            ]}
          >
            <Input maxLength={255} />
          </Form.Item>
        </Col>
        <Col md={12} sm={24} xs={24}>
          <Form.Item
            label="Etternavn"
            name="last_name"
            rules={[
              {
                required: true,
                message: "Skriv inn etternavn",
              },
              { max: 255, message: "Etternavn kan ikke være lengre enn 255 tegn" },
            ]}
          >
            <Input maxLength={255} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col md={8} sm={24} xs={24}>
          <Form.Item
            label="Telefonnummer"
            name="companyContactTelephone"
            rules={[
              {
                required: true,
                message: "Skriv inn telefonnummer",
              },
              { max: 255, message: "Telefonnummer kan ikke være lengre enn 255 tegn" },
            ]}
          >
            <Input maxLength={255} />
          </Form.Item>
        </Col>
        <Col md={8} sm={24} xs={24}>
          <Form.Item
            label="E-postadresse"
            name="companyContactEmail"
            rules={[
              {
                required: true,
                message: "Skriv inn E-postadresse",
              },
              { type: "email", message: "Skriv inn en gyldig epostadresse" },
              { max: 100, message: "E-postadresse kan ikke være lengre enn 100 tegn" },
            ]}
          >
            <Input maxLength={100} />
          </Form.Item>
        </Col>
        <Col md={8} sm={24} xs={24}>
          <Form.Item
            label="Stilling"
            name="position"
            rules={[{ max: 255, message: "Stilling kan ikke være lengre enn 255 tegn" }]}
          >
            <Input maxLength={255} />
          </Form.Item>
        </Col>
      </Row>

      <Title level={5}>Bedrift</Title>
      <Row gutter={24}>
        <Col md={12} sm={24} xs={24}>
          <Form.Item
            label="Nettside"
            name="url"
            rules={[{ max: 255, message: "Nettside kan ikke være lengre enn 255 tegn" }]}
          >
            <Input addonBefore="https://" maxLength={255} />
          </Form.Item>
        </Col>
        <Col md={12} sm={12} xs={24}>
          <Form.Item
            label="Organisasjonsnummer"
            name="organization_number"
            rules={[
              {
                required: true,
                message: "Skriv inn organisasjonsnummer",
              },
              { pattern: new RegExp(/^[0-9]+$/), message: "Organisasjonsnummer må være tall" },
              { max: 9, min: 9, message: "Organisasjonsnummer må være 9 siffer langt" },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col md={12} sm={24} xs={24}>
          <Form.Item
            label="E-postadresse"
            name="email"
            rules={[
              {
                required: true,
                message: "Skriv inn epostadresse",
              },
              { type: "email", message: "Skriv inn en gyldig epostadresse" },
              { max: 100, message: "E-postadresse kan ikke være lengre enn 100 tegn" },
            ]}
          >
            <Input maxLength={100} />
          </Form.Item>
        </Col>
        <Col md={12} sm={12} xs={24}>
          <Form.Item
            label="Telefonnummer"
            name="telephone"
            rules={[{ max: 255, message: "Telefonnummer kan ikke være lengre enn 255 tegn" }]}
          >
            <Input maxLength={255} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col md={12} sm={24} xs={24}>
          <Form.Item
            label="Postadresse"
            name="visitor_address"
            rules={[{ max: 255, message: "Postadresse kan ikke være lengre enn 255 tegn" }]}
          >
            <Input maxLength={255} />
          </Form.Item>
        </Col>
        <Col md={4} sm={12} xs={24}>
          <Form.Item
            label="Postnummer"
            name="visitor_area_code"
            rules={[{ max: 255, message: "Postnummer kan ikke være lengre enn 255 tegn" }]}
          >
            <Input maxLength={255} />
          </Form.Item>
        </Col>
        <Col md={4} sm={12} xs={24}>
          <Form.Item
            label="Poststed"
            name="visitor_region"
            rules={[{ max: 255, message: "Poststed kan ikke være lengre enn 255 tegn" }]}
          >
            <Input maxLength={255} />
          </Form.Item>
        </Col>
        <Col md={4} sm={12} xs={24}>
          <Form.Item
            label="Land"
            name="country"
            rules={[{ max: 255, message: "Land kan ikke være lengre enn 255 tegn" }]}
          >
            <Input maxLength={255} />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};

export default CompanyContactInformation;
